import Select from 'react-select';
import styled from 'styled-components';

export const Error = styled.span`
  font-size: 14px;
  margin-left: 14px;
  margin-right: 14px;
  text-align: left;
  color: ${({ theme }) => theme.colors.error};
`;

interface CSelectProps {
  circle?: boolean;
  error?: boolean;
}

// @ts-ignore
const CSelect = styled(Select).attrs((props) => ({
  ...props,
  classNamePrefix: 'cydea-select',
  className: `cydea-select ${props.className || ''}`.trim(),
  noOptionsMessage: () => '',
  isSearchable: false,
  styles: {
    container: (base: Record<string, unknown>) => ({
      ...base,
      background: 'transparent',
    }),
    ...props.styles,
  },
}))<CSelectProps>`
  min-width: 260px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.prussianBlue};

  .cydea-select__value-container {
    padding: 0 20px !important;
  }

  .cydea-select__control {
    cursor: pointer;
    border-radius: 3px;
    height: 52px;
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    ${({ error, theme }) => error && `border: 1px solid ${theme.colors.error}`};
    z-index: 3;
    background: ${({ theme }) => theme.colors.cultured};
    box-shadow: none;

    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.stroke};
    }

    &--is-focused {
      border: 1px solid ${({ theme }) => theme.colors.stroke};
      outline: none !important;
    }
    &--menu-is-open {
      .cydea-select__dropdown-indicator {
        transform: rotate(180deg);
      }
    }

    &--is-disabled {
      pointer-events: visible;
      cursor: not-allowed;
      .cydea-select__dropdown-indicator {
        color: transparent;
      }
    }
  }

  .cydea-select__menu {
    margin-top: 0px;
    filter: drop-shadow(0px 0px 37px ${({ theme }) => theme.colors.shadow});
    z-index: 1000;
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    box-shadow: 0px 0px 37px rgba(0, 0, 0, 0);
    transform: translateY(-2px);
    background: ${({ theme }) => theme.colors.white};
  }

  .cydea-select__menu-list {
    max-height: 400px;
  }

  .cydea-select__option {
    font-weight: 500;
    font-size: 14px;
    width: auto;
    padding: 0 12px;
    margin: 5px 8px;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.prussianBlue};

    &--is-disabled {
      background: ${({ theme }) => theme.colors.white} !important;
      border-radius: 3px;
      color: ${({ theme }) => theme.colors.cflowerBlue} !important;
      cursor: default !important;
    }

    &--is-selected {
      font-weight: 600;
    }

    &:hover {
      background: ${({ theme }) => theme.colors.gradient};
      border-radius: 3px;
      color: ${({ theme }) => theme.colors.btnWhite};
      cursor: pointer;
    }
  }

  .cydea-select__group-heading {
    font-size: 14px;
  }

  .cydea-select__value-container {
    padding: 0 26px;
  }
  .cydea-select__single-value {
    color: ${({ theme }) => theme.colors.prussianBlue};
    &--is-disabled {
      opacity: 0.5;
    }
  }

  .cydea-select__input-container {
    color: ${({ theme }) => theme.colors.prussianBlue};
  }

  .cydea-select__dropdown-indicator {
    color: ${({ theme }) => theme.colors.davysGrey};
    margin-right: 12px;
  }

  .cydea-select__indicator-separator {
    display: none;
  }

  .cydea-select__placeholder {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => (theme.scheme === 'light' ? theme.colors.cflowerBlue : '#848D9F')} !important;
    opacity: ${({ theme }) => (theme.scheme === 'light' ? 0.6 : 1)} !important;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 14px;
    height: 40px;

    .cydea-select__control {
      height: 40px;
    }
    .cydea-select__option {
      font-size: 14px;
      padding: 0 10px;
    }
    .cydea-select__group-heading {
      font-size: 14px;
    }
    .cydea-select__placeholder {
      font-size: 14px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 34px;
    font-size: 12px;

    .cydea-select__control {
      height: 34px;
    }
    .cydea-select__option {
      font-size: 12px;
      padding: 0 10px;
    }
    .cydea-select__group-heading {
      font-size: 12px;
    }
    .cydea-select__placeholder {
      font-size: 12px;
    }
  }
`;

export default CSelect;
